import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ChatWidget from './components/ChatWidget/ChatWidget';
import { ProtectedRoute, AdminRoute, PublicOnlyRoute } from './components/ProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';

import DashboardPage from './pages/DashboardPage';
import ClientsListPage from './pages/ClientsListPage';
import ClientDetailPage from './pages/ClientDetailPage';
import KnowledgeBasePage from './pages/KnowledgeBasePage';
import AdminKnowledgeBasePage from './pages/AdminKnowledgeBasePage';
import SettingsPage from './pages/SettingsPage';

function App() {
  const isEmbed = new URLSearchParams(window.location.search).get('embed') === 'true';

  useEffect(() => {
    if (isEmbed) {
      document.documentElement.style.background = 'transparent';
      document.body.style.background = 'transparent';
      document.body.style.margin = '0';
      document.body.style.padding = '0';
      document.body.style.overflow = 'hidden';
      var root = document.getElementById('root');
      if (root) {
        root.style.background = 'transparent';
      }
    }
  }, [isEmbed]);

  if (isEmbed) {
    return <ChatWidget />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<PublicOnlyRoute><LoginPage /></PublicOnlyRoute>} />

      <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/clients" element={<ClientsListPage />} />
        <Route path="/clients/:id" element={<ClientDetailPage />} />
        <Route path="/clients/:clientId/knowledge" element={<KnowledgeBasePage />} />
        <Route path="/admin/knowledge" element={<AdminRoute><AdminKnowledgeBasePage /></AdminRoute>} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
